import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { MasterDataStatusFilter, ActivationResult } from '../interfaces/masterDataStatus.interface';
import { Supplier, SupplierCreateDTO, SupplierResponse } from '../interfaces/procurement/supplier.interface';

export const SupplierService = {
  // FW-1: status omitted = ACTIVE (pickers for NEW documents); pass 'ALL' for list pages, reports and filters.
  listByInstitution: async (page = 0, size = 10, status?: MasterDataStatusFilter, forInstitutionId?: string): Promise<SupplierResponse> => {
    const institutionId = forInstitutionId ?? AuthService.getSelectedInstitution()!!;
    const res = await axios.get(`${ENDPOINTS.SUPPLIER.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}${status ? `&status=${status}` : ''}`);
    return res.data;
  },
  getById: async (id: string): Promise<Supplier> => (await axios.get(ENDPOINTS.SUPPLIER.GET_BY_ID(id))).data,
  create: async (dto: SupplierCreateDTO): Promise<Supplier> => (await axios.post(ENDPOINTS.SUPPLIER.CREATE, dto)).data,
  update: async (id: string, dto: SupplierCreateDTO): Promise<Supplier> => (await axios.put(ENDPOINTS.SUPPLIER.UPDATE(id), dto)).data,
  deactivate: async (id: string, reason?: string): Promise<ActivationResult> =>
    (await axios.post(ENDPOINTS.SUPPLIER.DEACTIVATE(id), { reason: reason?.trim() || undefined })).data,
  activate: async (id: string): Promise<ActivationResult> => (await axios.post(ENDPOINTS.SUPPLIER.ACTIVATE(id))).data,
  delete: async (id: string): Promise<void> => { await axios.delete(ENDPOINTS.SUPPLIER.DELETE(id)); },
};
